import styled from 'styled-components';

export const PrecedingSpan = styled.span`
  color: ${props => props.theme.colors.capsuleBlue50} !important;
`;
